
const header = [
  {key: 'home', title: '首页', to: '/'},
  {
    key: 'product',
    title: '产品',
    children: [
      {key: 'epld', title: '物流控制塔（EPLD）', to: '/product/epld'},
      {key: 'tms', title: '运输管理系统（TMS）', to: '/product/tms'},
      {key: 'wms', title: '仓储管理系统（WMS）', to: '/product/wms'},
      {key: 'dc', title: '数据中心', to: '/product/dc'},
      {key: 'erp', title: '云ERP系统', to: '/product/erp'},
    ]
  },
  {
    key: 'solution',
    title: '解决方案',
    children: [
      {key: 'transport', title: '网络货运平台解决方案', to: '/solution/transport'},
      {key: 'logistics', title: '综合物流服务解决方案', to: '/solution/logistics'},
      {key: 'finance', title: '供应链金融系统综合解决方案', to: '/solution/finance'},
    ]
  },
  {
    key: 'service',
    title: '综合服务',
    children: [
      {key: 'hr', title: '人力资源', to: '/service/hr/strategy'},
      {key: 'product', title: '产品运营', to: '/service/product/support'},
      {key: 'it', title: 'IT', to: '/service/it/schema'},
      {key: 'train', title: '综合培训', to: '/service/train/flow'},
      {key: 'ecology', title: '生态赋能', to: '/service/ecology/strategy'},
    ]
  },
  {
    key: 'case',
    title: '客户案例',
    children: [
      {key: 'composite', title: '综合物流案例', to: '/case/composite'},
      {key: 'smart', title: '智慧运输案例', to: '/case/smart'},
      {key: 'warehouse', title: '仓配案例', to: '/case/warehouse'},
      {key: 'optimize', title: '零担运输路径优化案例', to: '/case/optimize'},
      {key: 'bulk', title: '大宗物流案例', to: '/case/bulk'},
      {key: 'park', title: '园区物流案例', to: '/case/park'},
      {key: 'online', title: '综合电商平台案例', to: '/case/online'},
    ]
  },
  {key: 'about', title: '关于我们', to: '/about'}
];

const contact = {
  phone: '（0755）8252 9914',
  email: 'service@cloudlinkscm.com',
  company: '云恋科技'
};

const footer = {
  phone: '（0755）8252 9914',
  email: 'service@cloudlinkscm.com',
  abbr: '云恋科技',
  company: '深圳市云恋科技有限公司',
  address: '深圳市盐田区盐田街道明珠大道与深盐路交汇处西南侧海格云链大楼',
};

const copyright = {
  year: 2008,
  company: '深圳市云恋科技有限公司',
  icp: '粤ICP备17104734号'
};

export {header, contact, footer, copyright};


// WEBPACK FOOTER //
// ./src/routes/App/config.js